module.exports = __webpack_public_path__ + "static/media/shocked.9beea224.svg";